
import { useCallback } from "react";
import { Profile } from 'types/Profile.interface';

type Reducer = (state: Profile, action: any) => Profile

const Logger = (reducer: Reducer) => {
  const reducerWithLogger = useCallback((state: any, action: any) => {
    const next = reducer(state, action);
    console.group(`%cAction: %c${action.type}`, "color: lightgreen; font-weight: bold;", "color: white; font-weight: bold;", "color: lightblue; font-weight: lighter;");
    console.log("%cPrevious State:", "color: #9E9E9E; font-weight: 700;", state);
    console.log("%cAction:", "color: #00A7F7; font-weight: 700;", action);
    console.log("%cNext State:", "color: #47B04B; font-weight: 700;", next);
    console.groupEnd();
    return next;
  }, [reducer]);

  return reducerWithLogger;
}

export default Logger
